<template>
  <!-- SUCCESS MESSAGE -->
  <div v-if="success">
    <h1 class="text-center font-bold text-3xl">
      <font-awesome-icon icon="far fa-circle-check" size="3x" />
      <br />
      <br />
      Os dados foram enviados com sucesso!
      <br />
      <small v-if="questionnaire.footer">
        <v-md-preview :text="questionnaire.footer" class="text-xl font-sans" />
      </small>
      <small v-else>Obrigado por responer o questionário</small>
    </h1>
  </div>
  <!-- ERROR MESSAGE -->
  <div v-else-if="!open">
    <h1 class="text-center font-bold text-3xl">
      Parece que a pesquisa ainda não está disponível para ser respondida.
      <br />
      <br />
      Por favor, entre em contato com o administrador
    </h1>
  </div>
  <!-- QUESTIONNAIRE -->
  <div v-else>
    <!-- FORM DO GESTOR CABEÇALHO -->
    <div v-if="!intelligence" class="flex flex-wrap">
      <span class="ml-1 mr-auto">
        Município: <strong>{{ city.name }} - {{ state.code }}</strong>
      </span>

      <span class="ml-auto mr-1 text-indigo">
        <!-- <strong>Dúvidas?</strong> -->
      </span>
    </div>

    <div v-if="!answer && !intelligence" class="text-center mb-6">
      <p class="font-bold text-3xl mt-3 mx-4">
        Olá {{ userName }}! Bem-vindo ao(à) {{ questionnaire.title }}
      </p>

      <br />

      <p class="text-xl my-3 mx-4">
        Considerando os dados de seu município, por favor responda as questões a seguir.
      </p>

      <br />
      <br />

      <span class="text-md">
        <v-md-preview
          :text="questionnaire.header"
          class="text-xl font-sans mx-auto max-w-lg text-justify"
        />
      </span>
    </div>

    <div v-if="intelligence" class="w-full bg-white rounded shadow mb-4 py-4">
      <div class="img_container max-w-sm mx-auto">
        <img :src="questionnaire.logo" class="w-full h-full" />
      </div>

      <div class="text-center mt-24">
        <v-md-preview
          :text="questionnaire.header"
          class="text-xl font-sans mx-auto max-w-lg text-justify"
        />
      </div>
    </div>

    <div v-if="answer" class="text-center mb-6">
      <span class="font-bold text-3xl">
        Respondido por {{ questionnaire.answer.user }} em {{ questionnaire.answer.date }}
      </span>
    </div>

    <div v-if="!intelligence">
      <div v-for="topic in list" :key="`topic-${topic.id}`" class="bg-white rounded-md shadow mb-4">
        <div class="text-center mt-2 mb-4">
          <h2 class="text-3xl my-6">
            <font-awesome-icon :icon="topic.icon" size="lg" /> {{ topic.name }}
          </h2>

          <small>{{ topic.questions.length }} pergunta(s)</small>
        </div>

        <div
          v-for="question in topic.questions"
          :key="`question-${question.id}`"
          class="pb-4 border-b-2 border-gray-500"
        >
          <div>
            <v-md-preview
              :text="question.statement + (question.required ? ' <b>  *</b>' : '')"
              class="text-xl font-sans max-w-5xl"
            />
          </div>

          <div class="flex flex-wrap relative pergunta_gestor" v-if="question.type === 'NUMBER'">
            <div class="flex items-start justify-center w-max container_full">
              <small class="ml-auto my-auto left_text">
                <v-md-preview :text="question.left_label" />
              </small>
              <div class="mt-4">
                <button
                  v-for="value in 5"
                  :id="`${value}-${question.id}`"
                  :key="`${value}-${question.id}`"
                  class="btn-questionnaire"
                  :class="{
                    'btn-questionnaire-disabled': answer,
                  }"
                  type="button"
                  :disabled="answer || request"
                  @click="setValue($event, topic, question, value)"
                >
                  {{ value }}
                </button>
              </div>
              <small class="mr-auto my-auto right_text">
                <v-md-preview :text="question.right_label" />
              </small>
            </div>
          </div>

          <div class="mt-8 mb-8 ml-8 pr-8">
            <label class="form-label" :for="`text-${question.id}`"
              >Justifique a nota selecionada:</label
            >
            <label class="form-label" :for="`text-${question.id}`"
              ><b>*Este campo é crucial: a justificativa da nota oferece insights valiosos e detalhados, sendo mais significativa que a própria nota para entender e promover o desenvolvimento.</b>
              </label>
            <textarea
              :id="`text-${question.id}`"
              v-model="commentaries[question.id]"
              rows="10"
              class="w-full max-w-2xl border border-gray-500"
              :disabled="answer || request"
              @blur="resaveCommentariesAndAanswerQuestionOnly(question.id)"
            />
          </div>
        </div>

        <div class="flex flex-wrap mb-2" :class="{ hidden: !answer }">
          <h2 class="text-3xl my-auto ml-auto mr-2">Nota:</h2>
          <button :id="`btn-${topic.id}`" class="btn-questionnaire active" type="button" disabled>
            -
          </button>
        </div>
      </div>

      <div v-if="!answer" class="text-center">
        <button class="btn-indigo" type="button" @click="store">Responder Questionário</button>

        <br />

        <div v-if="error" class="form-error">Responda todas as questões!</div>
      </div>
    </div>
    <!-- QUESTIONNAIRE WITH INTELIGENCE -->
    <div v-else>
      <div v-if="section">
        <div
          v-for="topic in section.topics"
          :key="`topic-${topic.id}`"
          class="bg-white rounded-md shadow overflow-x-auto mb-4 overflow-y-hidden teste-overflow"
        >
          <div v-if="answer" class="text-center mt-2 mb-4">
            <h2 class="text-3xl">
              <font-awesome-icon :icon="topic.icon" size="lg" /> {{ topic.name }}
            </h2>

            <small>{{ topic.questions.length }} pergunta(s)</small>
          </div>

          <div v-for="question in topic.questions" :key="`question-${question.id}`">
            <div>
              <v-md-preview
                :text="question.statement + (question.required ? ' <b>  *</b>' : '')"
                class="text-xl font-sans"
              />
            </div>

            <!-- NOTA 1 A 5 -->
            <div v-if="question.type === 'NUMBER'" class="pb-8 pl-8">
              <div class="flex items-start justify-center w-max relative">
                <small class="ml-auto my-auto left_text">
                  <v-md-preview :text="question.left_label" />
                </small>
                <!-- <div class="mx-8"> -->
                <div class="mt-4">
                  <button
                    v-for="value in 5"
                    :id="`${value}-${question.id}`"
                    :key="`${value}-${question.id}`"
                    class="btn-questionnaire"
                    :class="{
                      'btn-questionnaire-disabled': answer,
                    }"
                    type="button"
                    :disabled="answer || request"
                    @click="setValue($event, topic, question, value)"
                  >
                    {{ value }}
                  </button>
                </div>
                <small class="mr-auto my-auto right_text">
                  <v-md-preview :text="question.right_label" />
                </small>
              </div>
            </div>

            <!-- ESCOLHA ÚNICA -->
            <div v-if="question.type === 'RADIO'" class="flex flex-wrap pb-8 pl-8">
              <div class="flex flex-col">
                <span
                  v-for="option in question.options"
                  :key="`${option.id}-${question.id}`"
                  class="btn-questionnaire-label flex items-start"
                >
                  <button
                    :id="`${option.id}-${question.id}`"
                    class="btn-questionnaire mr-0 mt-4"
                    :class="{
                      'btn-questionnaire-disabled': answer,
                    }"
                    type="button"
                    :disabled="answer || request"
                    @click="setText($event, question, option.alternative)"
                  />

                  <span class="text-lg">
                    <v-md-preview :text="option.alternative" />
                  </span>
                </span>
              </div>
            </div>

            <!-- MÚLTIPLA ESCOLHA -->
            <div v-if="question.type === 'CHECK'" class="flex flex-wrap pb-8 pl-8">
              <div class="mb-6 flex flex-col">
                <div
                  v-for="option in question.options"
                  :key="`${option.id}-${question.id}`"
                  class="btn-questionnaire-label mr-4 flex items-start"
                >
                  <button
                    :id="`${option.id}-${question.id}`"
                    class="btn-questionnaire h-5 w-5 rounded-none mt-4"
                    type="button"
                    @click="setMultiple($event, question, option.alternative)"
                  />

                  <span class="text-lg">
                    <v-md-preview :text="option.alternative" />
                  </span>
                </div>
              </div>
            </div>

            <!-- LINE -->
            <div v-if="question.type === 'LINE'" class="flex flex-wrap">
              <div class="mb-8 ml-8 mr-8 w-full max-w-2xl">
                <input
                  :id="`${question.id}-text`"
                  v-model="form[question.id]"
                  class="form-input"
                  type="text"
                  :disabled="answer || request"
                  @blur="setTextable(question.id)"
                />
              </div>
            </div>

            <!-- MULTILINE -->
            <div v-if="question.type === 'MULTI'" class="flex flex-wrap">
              <div class="mb-8 ml-8 mr-8 w-full max-w-2xl">
                <textarea
                  :id="`${question.id}-text`"
                  v-model="form[question.id]"
                  class="form-textarea"
                  rows="10"
                  :disabled="answer || request"
                  @blur="setTextable(question.id)"
                />
              </div>
            </div>

            <!-- SLIDER -->
            <div v-if="question.type === 'SLIDER'" class="flex flex-wrap">
              <div class="mb-8 ml-8 mr-8 w-full max-w-2xl">
                <span
                  v-for="(option, optionIndex) in question.options"
                  :key="`${option.id}-${question.id}`"
                  class="flex flex-wrap mb-20"
                  :class="{ 'mb-6': optionIndex !== question.options.length - 1 }"
                >
                  <label :for="`${option.id}-${question.id}-slider`" class="mb-12">
                    {{ option.alternative }}
                  </label>
                  <input
                    :id="`${option.id}-${question.id}-slider`"
                    v-model="form[question.id][option.id]"
                    class="w-full h-2 bg-gray-500 appearance-none rounded minwidth"
                    type="range"
                    step="1"
                    max="5"
                    min="0"
                    :disabled="answer || request"
                    :style="{ background: getColor(form[question.id][option.id]) }"
                    @change="setMultipleValue(question.id)"
                    list="legenda"
                  />
                  <!-- <div class="sliderticks">
                    <span>{{ question.slider_text_zero }}</span>
                    <span>{{ question.slider_text_one }}</span>
                    <span>{{ question.slider_text_two }}</span>
                    <span>{{ question.slider_text_three }}</span>
                    <span>{{ question.slider_text_four }}</span>
                    <span>{{ question.slider_text_five }}</span>
                  </div> -->
                  <div class="sliderticks">
                    <span class="slider_text_md"
                      ><v-md-preview :text="question.slider_text_zero"
                    /></span>
                    <span class="slider_text_md relative translate-y-14"
                      ><v-md-preview :text="question.slider_text_one"
                    /></span>
                    <span class="slider_text_md"
                      ><v-md-preview :text="question.slider_text_two"
                    /></span>
                    <span class="slider_text_md"
                      ><v-md-preview :text="question.slider_text_three"
                    /></span>
                    <span class="slider_text_md"
                      ><v-md-preview :text="question.slider_text_four"
                    /></span>
                    <span class="slider_text_md"
                      ><v-md-preview :text="question.slider_text_five"
                    /></span>
                  </div>
                </span>
              </div>
            </div>

            <div class="text-center w-1/2 mx-auto mt-2 mb-4 hidden">
              <label class="form-label" :for="`text-${question.id}`"
                >Justifique a nota selecionada</label
              >

              <textarea
                :id="`text-${question.id}`"
                v-model="commentaries[question.id]"
                rows="10"
                class="form-textarea"
                :disabled="answer"
              />
            </div>
          </div>

          <div class="flex flex-wrap mb-2 hidden">
            <h2 class="text-3xl my-auto ml-auto mr-2">Nota:</h2>
            <button :id="`btn-${topic.id}`" class="btn-questionnaire active" type="button" disabled>
              -
            </button>
          </div>
        </div>

        <div v-if="!answer">
          <button
            v-if="!section.next_section_id"
            class="btn-indigo"
            type="button"
            :disabled="request"
            @click="store"
          >
            Responder Questionário
          </button>
          <template v-else>
            <div class="text-center">
              <div class="flex">
                <button
                  v-if="section.id !== set[0].id"
                  class="btn-gray mr-4"
                  type="button"
                  @click="previous"
                >
                  Anterior
                </button>

                <button
                  v-if="section.id !== set[set.length - 1].id"
                  class="btn-indigo"
                  type="button"
                  @click="next"
                >
                  Próximo
                </button>
              </div>
            </div>
          </template>

          <br />

          <div v-if="error" class="form-error">Responda todas as questões!</div>
        </div>
        <div v-else class="text-center">
          <div class="flex">
            <button
              v-if="section.id !== set[0].id"
              class="btn-indigo"
              :class="{
                'mx-auto': section.id === set[set.length - 1].id,
                'ml-auto mr-1': section.id !== set[set.length - 1].id,
              }"
              type="button"
              @click="previous"
            >
              Anterior
            </button>

            <button
              v-if="section.id !== set[set.length - 1].id"
              class="btn-indigo"
              :class="{
                'mx-auto': section.id === set[0].id,
                'mr-auto ml-1': section.id !== set[0].id,
              }"
              type="button"
              @click="next"
            >
              Próximo
            </button>
          </div>
        </div>
      </div>
      <!-- end section above -->
    </div>
  </div>
</template>

<script>
import Layout from '@/Pages/Questionnaires/Layout'
import axios from 'axios'

export default {
  metaInfo() {
    return {
      title: this.questionnaire.title,
    }
  },
  layout: Layout,
  props: {
    questionnaire: Object,
    intelligence: Boolean,
    list: Array,
    set: Array,
    state: Object,
    city: Object,
    success: Boolean,
    code: String,
    answer: Boolean,
    open: Boolean,
  },
  data() {
    return {
      form: {},
      values: {},
      commentaries: {},
      error: false,
      userName: this.$page?.props?.auth?.user
        ? `${this.$page.props.auth.user.first_name} ${this.$page.props.auth.user.last_name}`
        : 'Gestor',
      reverseIndex: {},
      section: null,
      previousSection: null,
      answerCode: this.code,
      request: false,
    }
  },
  mounted() {
    setTimeout(() => {
      for (const preview of document.getElementsByClassName('v-md-editor-preview')) {
        for (const child of preview.getElementsByTagName('*')) {
          child.classList.add('font-sans', 'text-xl')
        }
      }

      for (const previewRight of document.getElementsByClassName('right_text')) {
        for (const child of previewRight.getElementsByTagName('*')) {
          for (const editor of child.getElementsByTagName('*')) {
            for (const x of editor.getElementsByTagName('*')) {
              x.classList.add('font-sans', 'text-sm')
              x.classList.remove('text-xl')
            }
          }
        }
      }

      for (const previewRight of document.getElementsByClassName('left_text')) {
        for (const child of previewRight.getElementsByTagName('*')) {
          for (const editor of child.getElementsByTagName('*')) {
            for (const x of editor.getElementsByTagName('*')) {
              x.classList.add('font-sans', 'text-sm')
              x.classList.remove('text-xl')
            }
          }
        }
      }

      for (const previewRight of document.getElementsByClassName('slider_text_md')) {
        for (const child of previewRight.getElementsByTagName('*')) {
          for (const editor of child.getElementsByTagName('*')) {
            for (const x of editor.getElementsByTagName('*')) {
              x.classList.add('font-sans', 'text-xs')
              x.classList.add('p-0')
              x.classList.add('m-0')
              x.classList.remove('text-xl')
              x.classList.remove('text-sm')
            }
          }
        }
      }
    }, 2.5e2)

    document.getElementById('q-name').innerText = this.questionnaire.title

    const q_ = (key) => {
      const q_key = localStorage.getItem(`q-${key}`)

      if (q_key) {
        return JSON.parse(q_key)
      }

      return null
    }

    const { id: q_id, code: q_code } = q_('id') ?? { id: null, code: null }
    const q_form = q_('form')
    const q_values = q_('values')
    const q_commentaries = q_('commentaries')
    const q_section = q_('section')

    const same_q = Boolean(q_id && q_id === this.questionnaire.id && !this.answer)

    if (this.intelligence) {
      if (this.answer) {
        this.removeStorageItems()
      }

      for (const index in this.set) {
        const numeric = Number(index)
        const section = this.set[numeric]

        if (!this.section) {
          this.section = same_q ? q_section : section

          if (same_q) {
            this.answerCode = q_code
          }
        }

        this.reverseIndex[section.id] = numeric

        for (const topic of section.topics) {
          this.values[topic.id] = null

          for (const question of topic.questions) {
            this.form[question.id] = (() => {
              if (question.type === 'SLIDER') {
                const sub = {}

                for (const option of question.options) {
                  sub[option.id] = 0
                }

                return sub
              }

              return null
            })()

            this.commentaries[question.id] = null

            if (section.id === this.section.id) {
              console.log(same_q)
              if (same_q) {
                if (q_form?.[question.id]) {
                  switch (question.type) {
                    case 'NUMBER':
                      this.setValueTimeout(q_form[question.id], question.id, topic, question)
                      break

                    case 'RADIO':
                      for (const option of question.options) {
                        if (option.alternative === q_form[question.id]) {
                          this.setTextTimeout(option.id, question.id, question, option.alternative)
                        }
                      }
                      break

                    case 'CHECK':
                      for (const option of question.options) {
                        if (q_form[question.id].includes(option.alternative)) {
                          this.setMultipleTimeout(
                            option.id,
                            question.id,
                            question,
                            option.alternative,
                          )
                        }
                      }
                      break

                    case 'LINE':
                    case 'MULTI':
                      this.setTextableTimeout(question.id, q_form[question.id])
                      break

                    case 'SLIDER':
                      this.setMultipleValueTimeout(question.id, q_form[question.id])
                      break
                  }
                }

                if (q_commentaries?.[question.id]) {
                  this.setCommentaryTimeout(question.id, q_commentaries[question.id])
                }

                continue
              }

              if (question.answer) {
                switch (question.type) {
                  case 'NUMBER':
                    this.setValueTimeout(question.answer, question.id, topic, question)
                    break

                  case 'RADIO':
                    for (const option of question.options) {
                      if (option.alternative === question.answer) {
                        this.setTextTimeout(option.id, question.id, question, option.alternative)
                      }
                    }
                    break

                  case 'CHECK':
                    for (const option of question.options) {
                      if (question.answer.includes(option.alternative)) {
                        this.setMultipleTimeout(
                          option.id,
                          question.id,
                          question,
                          option.alternative,
                        )
                      }
                    }
                    break

                  case 'LINE':
                  case 'MULTI':
                    this.setTextableTimeout(question.id, question.answer)
                    break

                  case 'SLIDER':
                    this.setMultipleValueTimeout(question.id, question.answer)
                    break
                }
              }

              if (question.commentary) {
                this.setCommentaryTimeout(question.id, question.commentary)
              }
            }
          }
        }
      }

      return
    }

    if (this.answer) {
      this.removeStorageItems()

      this.list.forEach((topic) => {
        this.values[topic.id] = null

        topic.questions.forEach((question) => {
          this.form[question.id] = null
          this.commentaries[question.id] = null

          this.setValueTimeout(question.answer, question.id, topic, question)

          this.setCommentaryTimeout(question.id, question.commentary)
        })
      })

      return
    }

    if (same_q) {
      this.answerCode = q_code

      this.list.forEach((topic) => {
        this.values[topic.id] = null

        if (q_values?.[topic.id]) {
          this.values[topic.id] = q_values[topic.id]
        }

        topic.questions.forEach((question) => {
          this.form[question.id] = null
          this.commentaries[question.id] = null

          if (q_form?.[question.id]) {
            this.setValueTimeout(q_form[question.id], question.id, topic, question)
          }

          if (q_commentaries?.[question.id]) {
            this.setCommentaryTimeout(question.id, q_commentaries[question.id])
          }
        })
      })
    } else {
      this.removeStorageItems()
    }

    console.log(this.questionnaire)
    console.log(this.list)
    console.log(this.section)
  },
  methods: {
    store() {
      this.error = false

      if (this.intelligence) {
        if (!this.answer) {
          for (const topic of this.section.topics) {
            for (const question of topic.questions) {
              if (question.required && this.form[question.id] === null) {
                this.error = true

                return
              }
            }
          }
        }
      } else {
        const formCount = Object.values(this.form).filter((value) => !!value).length
        const questionCount = (() => {
          let count = 0

          this.list.forEach((topic) => topic.questions.forEach(() => count++))

          return count
        })()

        if (formCount < questionCount) {
          this.error = true

          return
        }
      }

      this.removeStorageItems()

      this.$inertia.post(this.route('questionnaire.answer', { url: this.questionnaire.url }), {
        id: this.questionnaire.id,
        questions: this.form,
        commentaries: this.commentaries,
        code: this.answerCode,
      })
    },
    previous() {
      const comparables = []

      for (const index in this.set) {
        const numeric = Number(index)
        const section = this.set[numeric]

        if (numeric > this.reverseIndex[this.section.id]) {
          break
        }

        if (section.next_section_id === this.section.id) {
          comparables.push(section)
        }
      }

      for (const section of comparables) {
        if (section.when === 'IF') {
          const comparable = section.number_value ?? section.text_value

          if (this.form[section.question_id] === comparable) {
            this.section = this.set[this.reverseIndex[section.id]]

            if (this.answer) {
              this.setSection()
            } else {
              this.setSectionFromStorage()
            }

            return
          }
        }
      }

      for (const section of comparables) {
        if (section.when === 'EVER') {
          this.section = this.set[this.reverseIndex[section.id]]

          if (this.answer) {
            this.setSection()
          } else {
            this.setSectionFromStorage()
          }

          return
        }
      }

      this.section = this.set[this.reverseIndex[this.section.id] - 1]

      if (this.answer) {
        this.setSection()
      } else {
        this.setSectionFromStorage()
      }
    },
    next() {
      this.error = false

      if (!this.answer) {
        for (const topic of this.section.topics) {
          for (const question of topic.questions) {
            if (question.required && this.form[question.id] === null) {
              this.error = true

              return
            }
          }
        }
      }

      this.previousSection = this.section.id

      if (this.section.when === 'IF') {
        const comparable = this.section.number_value ?? this.section.text_value

        if (this.form[this.section.question_id] === comparable) {
          this.section = this.set[this.reverseIndex[this.section.next_section_id]]

          if (this.answer) {
            this.setSection()
          } else {
            this.setSectionFromStorage()
          }

          return
        }

        this.section = this.set[this.reverseIndex[this.section.id] + 1]

        if (this.answer) {
          this.setSection()
        } else {
          this.setSectionFromStorage()
        }

        return
      }

      this.section = this.set[this.reverseIndex[this.section.next_section_id]]

      if (this.answer) {
        this.setSection()
      } else {
        this.setSectionFromStorage()
      }
    },
    setSection() {
      for (const topic of this.section.topics) {
        for (const question of topic.questions) {
          if (question.answer) {
            switch (question.type) {
              case 'NUMBER':
                this.setValueTimeout(question.answer, question.id, topic, question)
                break

              case 'RADIO':
                for (const option of question.options) {
                  if (option.alternative === question.answer) {
                    this.setTextTimeout(option.id, question.id, question, option.alternative)
                  }
                }
                break

              case 'CHECK':
                for (const option of question.options) {
                  if (question.answer.includes(option.alternative)) {
                    this.setMultipleTimeout(option.id, question.id, question, option.alternative)
                  }
                }
                break

              case 'LINE':
              case 'MULTI':
                this.setTextableTimeout(question.id, question.answer)
                break

              case 'SLIDER':
                this.setMultipleValueTimeout(question.id, question.answer)
                break
            }
          }

          if (question.commentary) {
            this.setCommentaryTimeout(question.id, question.commentary)
          }
        }
      }
    },
    setSectionFromStorage() {
      const { q_form, q_commentaries } = (() => {
        const q_ = {
          q_form: null,
          q_commentaries: null,
        }

        for (const key of ['form', 'commentaries']) {
          const q_key = localStorage.getItem(`q-${key}`)

          if (q_key) {
            q_[`q_${key}`] = JSON.parse(q_key)
          }
        }

        return q_
      })()

      for (const topic of this.section.topics) {
        for (const question of topic.questions) {
          if (q_form?.[question.id]) {
            switch (question.type) {
              case 'NUMBER':
                this.setValueTimeout(q_form[question.id], question.id, topic, question)
                break

              case 'RADIO':
                for (const option of question.options) {
                  if (option.alternative === q_form[question.id]) {
                    this.setTextTimeout(option.id, question.id, question, option.alternative)
                  }
                }
                break

              case 'CHECK':
                for (const option of question.options) {
                  if (q_form[question.id].includes(option.alternative)) {
                    this.setMultipleTimeout(option.id, question.id, question, option.alternative)
                  }
                }
                break

              case 'LINE':
              case 'MULTI':
                this.setTextableTimeout(question.id, q_form[question.id])
                break

              case 'SLIDER':
                this.setMultipleValueTimeout(question.id, q_form[question.id])
                break
            }
          }

          if (q_commentaries?.[question.id]) {
            this.setCommentaryTimeout(question.id, q_commentaries[question.id])
          }
        }
      }
    },
    setValue(event, topic, question, value, noAxios = false) {
      const btn = event.target
      const group = btn.parentElement

      for (const gbtn of group.children) {
        gbtn.classList.remove('active')
      }

      btn.classList.add('active')

      this.form[question.id] = value

      this.values[topic.id] = 0

      topic.questions.forEach((question) => {
        if (this.form[question.id]) {
          this.values[topic.id] += this.form[question.id]
        }
      })

      this.values[topic.id] /= topic.questions.length

      document.getElementById(`btn-${topic.id}`).innerText = this.values[topic.id].toFixed(1)

      this.setStorageItems()

      if (!noAxios) {
        this.answerQuestionOnly(question.id).then(() => {
          if (this.intelligence) {
            if (this.section.next_section_id) {
              let qtdQuestions = 0
              for (const topic of this.section.topics) {
                for (const question of topic.questions) {
                  qtdQuestions++
                }
              }

              if (qtdQuestions == 1) {
                this.next()
              }
            }
          }
        })
      }
    },
    setValueTimeout(answer, id, topic, question, noSend = true) {
      setTimeout(
        () =>
          this.setValue(
            { target: document.getElementById(`${answer}-${id}`) },
            topic,
            question,
            Number(answer),
            noSend,
          ),
        5e2,
      )
    },
    setText(event, question, text, noAxios = false) {
      const btn = event.target
      const group = btn.parentElement.parentElement

      for (const pair of group.children) {
        const button = pair.firstElementChild
        const label = pair.lastElementChild

        button.classList.remove('active')

        if (this.answer) {
          label.classList.remove('disabled')

          if (button.id !== btn.id) {
            label.classList.add('disabled')
          }
        }
      }

      btn.classList.add('active')

      this.form[question.id] = text

      this.setStorageItems()

      if (!noAxios) {
        this.answerQuestionOnly(question.id).then(() => {
          if (this.intelligence) {
            if (this.section.next_section_id) {
              let qtdQuestions = 0
              for (const topic of this.section.topics) {
                for (const question of topic.questions) {
                  qtdQuestions++
                }
              }

              if (qtdQuestions == 1) {
                this.next()
              }
            }
          }
        })
      }
    },
    setTextTimeout(id, question_id, question, alternative, noSend = true) {
      setTimeout(
        () =>
          this.setText(
            { target: document.getElementById(`${id}-${question_id}`) },
            question,
            alternative,
            noSend,
          ),
        5e2,
      )
    },
    setTextable(question_id, noAxios = false) {
      this.setStorageItems()

      if (!noAxios) {
        this.answerQuestionOnly(question_id).then(() => {
          if (this.intelligence) {
            if (this.section.next_section_id) {
              // this.next()
            }
          }
        })
      }
    },
    setTextableTimeout(id, text) {
      setTimeout(() => {
        document.getElementById(`${id}-text`).value = text

        this.form[id] = text
      }, 5e2)
    },
    setMultiple(event, question, one, noAxios = false) {
      const btn = event.target
      const group = btn.parentElement.parentElement

      if (btn.classList.contains('active')) {
        btn.classList.remove('active')

        const newMultiple = this.form[question.id].filter((value) => value !== one)
        this.form[question.id] = newMultiple
      } else {
        btn.classList.add('active')
        if (!this.form[question.id]) {
          this.form[question.id] = []
        }

        this.form[question.id].push(one)
      }

      if (this.answer) {
        for (const pair of group.children) {
          const button = pair.firstElementChild
          const label = pair.lastElementChild

          if (button.classList.contains('active')) {
            label.classList.remove('disabled')

            continue
          }

          label.classList.add('disabled')
        }
      }

      this.setStorageItems()

      if (!noAxios) {
        this.answerQuestionOnly(question.id)
      }
    },
    setMultipleTimeout(id, question_id, question, alternative, noSend = true) {
      setTimeout(
        () =>
          this.setMultiple(
            { target: document.getElementById(`${id}-${question_id}`) },
            question,
            alternative,
            noSend,
          ),
        5e2,
      )
    },
    setMultipleValue(question_id, noAxios = false) {
      this.setStorageItems()

      if (!noAxios) {
        this.answerQuestionOnly(question_id)
      }
    },
    setMultipleValueTimeout(id, options) {
      setTimeout(() => {
        for (const option in options) {
          document.getElementById(`${option}-${id}-slider`).value = options[option]
        }

        this.form[id] = options
      }, 5e2)
    },
    setCommentaryTimeout(question_id, commentary) {
      setTimeout(() => {
        document.getElementById(`text-${question_id}`).value = commentary

        this.commentaries[question_id] = commentary
      }, 5e2)
    },
    answerQuestionOnly(question_id) {
      if (this.request) {
        return
      }

      const data = {
        _token: this.$page.props.auth.user?.csrf_token,
        question: question_id,
      }

      const value = this.form[question_id]

      let type = null

      switch (typeof value) {
        case 'number':
          type = 'number'
          break
        case 'string':
          type = 'text'
          break
        case 'object':
          type = 'multi'
      }

      if (type) {
        data[`${type}_value`] = value
      }

      const commentary = this.commentaries[question_id]

      if (commentary) {
        data.commentary = commentary
      }

      // this.request = true

      const btns = document.getElementsByClassName('btn-questionnaire')
      const actives = []

      for (const btn of btns) {
        if (btn.classList.contains('active')) {
          actives.push(btn)
        }

        btn.classList.remove('active')
        // btn.classList.add('btn-questionnaire-disabled')
      }

      return axios
        .post(
          this.route('questionnaire.answer.question', {
            url: this.questionnaire.url,
            code: this.answerCode,
          }),
          data,
        )
        .finally(() => {
          for (const btn of btns) {
            btn.classList.remove('btn-questionnaire-disabled')

            if (actives.includes(btn)) {
              btn.classList.add('active')
            }
          }

          // this.request = false
        })
    },
    resaveCommentariesAndAanswerQuestionOnly(question_id) {
      this.setStorageItems()

      return this.answerQuestionOnly(question_id)
    },
    isTopicNumberOnly(topic) {
      for (const question of topic.questions) {
        if (question.type !== 'NUMBER') {
          return false
        }
      }

      return true
    },
    setStorageItems() {
      localStorage.setItem('q-id', JSON.stringify({ ...this.questionnaire, code: this.answerCode }))
      localStorage.setItem('q-form', JSON.stringify(this.form))
      localStorage.setItem('q-values', JSON.stringify(this.values))
      localStorage.setItem('q-commentaries', JSON.stringify(this.commentaries))
      localStorage.setItem('q-section', JSON.stringify(this.section))
    },
    removeStorageItems() {
      localStorage.removeItem('q-id')
      localStorage.removeItem('q-form')
      localStorage.removeItem('q-values')
      localStorage.removeItem('q-commentaries')
    },
    getColor(value) {
      switch (value) {
        case '0':
          return '#78716c'
        case '1':
          return '#ef4444'
        case '2':
          return '#f97316'
        case '3':
          return '#eab308'
        case '4':
          return '#84cc16'
        case '5':
          return '#22c55e'
      }
    },
  },
}
</script>
<style scoped>
@media screen and (max-width: 700px) {
  .left_text {
    position: absolute;
    left: 0px;
    top: -22px;
    pointer-events: none;
    font-size: 12px !important;
  }

  .right_text {
    position: absolute;
    right: 0px;
    top: 35px;
    pointer-events: none;
  }

  .container_full {
    margin: 0 auto;
  }

  .pergunta_gestor {
    margin-bottom: 50px;
  }
}

.sliderticks {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  min-width: 500px;
}

.minwidth {
  min-width: 500px;
}

.sliderticks span {
  display: flex;
  justify-content: center;
  width: 1px;
  height: 10px;
  line-height: 20px;
}

.teste-overflow {
  overflow-y: hidden;
}
</style>
